<template>
  <BContainer class="container-pages" v-if="images && images.length">
    <!-- GLAVNA SLIKA -->
    <BRow>
      <BCol class="big-image-holder">
        <div class="main-image-wrapper">
          <!-- ⬅️ strelica -->
          <button
            v-if="hasMultiple"
            class="gallery-arrow left"
            type="button"
            aria-label="Previous image"
            @click="prev"
          >
            <i class="esei icon-angle-left-solid"></i>
          </button>

          <NuxtImg
            class="mt-2 img-fluid"
            fit="cover"
            
            loading="lazy"
            decoding="async"
            :src="$getImageSrc(activeImage.medium)"
            :alt="alt"
          />

          <!-- ➡️ strelica -->
          <button
            v-if="hasMultiple"
            class="gallery-arrow right"
            type="button"
            aria-label="Next image"
            @click="next"
          >
            <i class="esei icon-angle-right-solid"></i>
          </button>
        </div>
      </BCol>
    </BRow>

    <!-- THUMBNAILS -->
    <BRow>
      <BCol class="thumbsHolder">
        <div class="thumbsHolderInner">
          <NuxtImg
            v-for="(img, i) in images"
            :key="img.id ?? i"
            :src="$getImageSrc(img.small)"
            :alt="`${alt} – slika ${i + 1}`"
            width="60"
            height="60"
            class="thumb-image mb-2"
            :class="{ active: img === activeImage }"
            loading="lazy"
            decoding="async"
            @click="setActive(img)"
          />
        </div>
      </BCol>
    </BRow>
  </BContainer>
</template>

<script setup>
import { ref, watch, computed } from 'vue'
import { BContainer, BRow, BCol } from 'bootstrap-vue-next'

const props = defineProps({
  images: {
    type: Array,
    required: true
  },
  initialImage: {
    type: Object,
    default: null
  },
  alt: {
    type: String,
    default: 'Cene i oglasi na pijacama'
  }
})

const activeImage = ref(props.initialImage || props.images[0])

watch(
  () => props.initialImage,
  (val) => {
    if (val) activeImage.value = val
  }
)

const hasMultiple = computed(() => props.images.length > 1)

function setActive(img) {
  activeImage.value = img
}

function prev() {
  const idx = props.images.indexOf(activeImage.value)
  activeImage.value =
    idx <= 0 ? props.images[props.images.length - 1] : props.images[idx - 1]
}

function next() {
  const idx = props.images.indexOf(activeImage.value)
  activeImage.value =
    idx >= props.images.length - 1 ? props.images[0] : props.images[idx + 1]
}
</script>

 